import { IDocument } from '../shared/interview-new/+components/summary/interview-summary-document/interview-summary-document.component';
export interface IDocumentType {
    id: number;
    label: string;
    description: string;
    version: string;
    showInUI: boolean;
    type: string;
    metadata: IDocumentTypeMetadata;
    active: boolean;
}

export interface IDocumentTypeMetadata {
    category?: string;
    elynk?: DocumentTypeELynk;
    templateManager?: IDocumentTypeTemplateManager;
    classification?: IDocumentTypeDocumentClassification;

}

export interface DocumentTypeELynk {
    packets: DocumentTypeELynkPacket[];
}

export interface DocumentTypeELynkPacket {
    id: string;
    add?: DocumentTypeELynkPacketAdd,
    checklist?: DocumentTypeELynkPacketChecklist,
}
export interface DocumentTypeELynkPacketChecklist{
    categoryId?: string;
    mode: DocumentTypeELynkPacketChecklistMode;
    editable: boolean;
}
export enum DocumentTypeELynkPacketChecklistMode {
    Required = 'Required',
    Optional = 'Optional'
}

export interface DocumentTypeELynkPacketAdd {
    mode: DocumentTypeELynkPacketAddMode;
    editable: boolean;
}

export enum DocumentTypeELynkPacketAddMode {
    Hidden = 'Hidden',
    Visible = 'Visible'
}

export interface IDocumentResponse {
    id: number;

    type: string;

    version: string;

    uri: string;

    metadata: any;

    base64EncodedContent: string;

    deleted: boolean;

    createdBy: string;

    createdOn?: Date;

    facilityId: string;

    direction: DocumentDirection;

    Remediated: boolean;

    validationMetaData: any;
}

export enum DocumentDirection {
    Incoming = 0,
    Outgoing
}


export interface IDocumentTypeTemplateManager {
    visible: boolean;
}

export interface IDocumentTypeDocumentClassification {
    scanning?: IDocumentClassificationScanning;
    upload?: IDocumentClassificationUpload;
}

export interface IDocumentClassificationScanning {
    visible: boolean;
}

export interface IDocumentClassificationUpload {
    visible: boolean;
}


export interface IDocumentTypeFunctionalAreasSelected {
  elynk: boolean;
  templateManager: boolean;
  documentClassification: boolean;
}


